export function staffRevenueAnalytics(state = [], action) {
  switch (action.type) {
    case "STAFF_REVENUE_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.staffRevenueAnalytics;
    default:
      return state;
  }
}
